/**
 * Created by razial on 14.04.2026.
 */

const RewardedPromo = function () {
    this.crossId = undefined;
    this.promotion = undefined;
    this.lastShown = 0;

    this.load();
};

RewardedPromo.prototype.load = function () {
    const syncedData = cleverapps.syncedStorage.load("promotasks") || {};

    this.crossId = syncedData.crossId;
    this.lastShown = syncedData.lastShown || 0;
    this.guideShown = syncedData.guideShown || false;
    this.endShown = syncedData.endShown || false;
    this.completedProjects = syncedData.completedProjects || [];
    this.seenCompleted = syncedData.seen || 0;

    this.loggedAvailable = syncedData.loggedAvailable || false;
    this.loggedShown = syncedData.loggedShown || false;
    this.loggedFirstLaunch = syncedData.loggedFirstLaunch || false;

    this.loadPromo();
};

RewardedPromo.prototype.loadPromo = function () {
    if (!this.crossId) {
        return;
    }

    const crossId = this.crossId;

    connector.multi.rewardedpromo.loadData(crossId, (error, data) => {
        if (this.crossId !== crossId) {
            return;
        }

        if (error) {
            return;
        }

        if (!data || !data.projectId || !RewardedPromoConfig.PROJECTS[data.projectId]) {
            this.crossId = undefined;
            this.save();
            cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
            return;
        }

        if (!this.promotion) {
            this.promotion = new RewardedPromotion(crossId);
        }

        this.promotion.updateData(data);
        this.promotion.claimed = data.claimed || 0;

        if (!data.finish) {
            // a record from before the schedule: it ends with the window of its target, or now when none is open
            const event = RewardedPromo.getScheduledEvent(this.promotion.projectId);
            this.promotion.finish = event ? event.finish.getTime() : Date.now();
            connector.multi.rewardedpromo.updateData(crossId, { finish: this.promotion.finish });
        }

        if (this.promotion.isEnded() && !this.promotion.hasUnclaimedRewards()) {
            this.acknowledgeEnd();
            return;
        }

        cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
    });
};

RewardedPromo.prototype.save = function () {
    cleverapps.syncedStorage.save("promotasks", {
        crossId: this.crossId,
        lastShown: this.lastShown || undefined,
        guideShown: this.guideShown || undefined,
        endShown: this.endShown || undefined,
        completedProjects: this.completedProjects.length ? this.completedProjects : undefined,
        seen: this.seenCompleted || undefined,

        loggedAvailable: this.loggedAvailable || undefined,
        loggedShown: this.loggedShown || undefined,
        loggedFirstLaunch: this.loggedFirstLaunch || undefined
    });
};

RewardedPromo.prototype.reset = function () {
    this.crossId = undefined;
    this.lastShown = 0;
    this.promotion = undefined;
    this.guideShown = false;
    this.endShown = false;
    this.completedProjects = [];
    this.seenCompleted = 0;

    this.loggedAvailable = false;
    this.loggedShown = false;
    this.loggedFirstLaunch = false;
    this.save();

    cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
};

RewardedPromo.prototype.logCrossOnce = function (flag, eventName) {
    if (this[flag]) {
        return;
    }

    cleverapps.metrics.logEvent(`${eventName}-${this.promotion.projectId}`, { itemId: this.promotion.schedule });
    this[flag] = true;
    this.save();
};

RewardedPromo.prototype.switchGame = function () {
    const link = this.promotion && this.promotion.getLink();
    if (!link) {
        return;
    }

    connector.platform.switchGame(link, this.promotion.getPayload());

    this.logCrossOnce("loggedFirstLaunch", cleverapps.EVENTS.CPROMO_FIRSTLAUNCH);
};

// a task the promoted game reports completed, not yet shown completed to the player: the window opens it as an
// open task and animates the completion once, then the bit is set
RewardedPromo.prototype.isCompletionUnseen = function (task) {
    return task.isCompleted() && !task.isClaimed() && !(this.seenCompleted & (1 << task.config.bit));
};

RewardedPromo.prototype.markCompletionSeen = function (task) {
    this.seenCompleted |= (1 << task.config.bit);
    this.save();
};

RewardedPromo.prototype.listUnseenCompleted = function () {
    return this.promotion ? this.promotion.tasks.slice(0, -1).filter((task) => this.isCompletionUnseen(task)) : [];
};

RewardedPromo.prototype.countShownCompletedTasks = function () {
    return this.promotion.countCompletedTasks() - this.listUnseenCompleted().length;
};

RewardedPromo.prototype.receiveReward = function (task) {
    const rewards = new RewardsList(task.getRewards(), {
        event: cleverapps.EVENTS.EARN.REWARDED_PROMO
    });
    rewards.receiveRewards();

    this.promotion.claimed |= (1 << task.config.bit);
    connector.multi.rewardedpromo.updateData(this.crossId, { claimed: this.promotion.claimed });

    task.onRewardReceived(rewards);

    this.promotion.tasks.forEach((t) => t.onUpdate());
    cleverapps.sideBar.resetByClassName(RewardedPromoIcon);

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CPROMO_RECEIVED}-${this.promotion.projectId}-${task.config.bit}`);

    return rewards;
};

RewardedPromo.prototype.isAvailable = function () {
    return cleverapps.crossPromo && cleverapps.crossPromo.isAvailable() && connector.platform.canPassPayload()
        && (!cleverapps.flags.norest || cleverapps.isLocalhost()) && cleverapps.user.checkAvailable(cleverapps.config.availables.REWARDED_PROMO)
        && cleverapps.meta.getSelectedLocation().locationConfig.isMain;
};

RewardedPromo.prototype.canDisplay = function () {
    return this.isAvailable() && connector.platform.isConnected();
};

RewardedPromo.prototype.isPromoting = function (projectId) {
    if (this.promotion && this.promotion.projectId === projectId && this.promotion.isActive()) {
        return true;
    }

    return Boolean(RewardedPromoConfig.PROJECTS[projectId] && RewardedPromo.getScheduledEvent(projectId));
};

RewardedPromo.prototype.chooseAndDisplay = function () {
    if (this.promotion && this.promotion.isEnded() && !this.promotion.hasUnclaimedRewards()) {
        this.acknowledgeEnd();
    }

    if (!this.isAvailable()) {
        return;
    }

    if (this.crossId && !this.promotion) {
        return;
    }

    if (this.promotion && this.promotion.isEnded()) {
        cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
        if (!this.endShown) {
            this.endShown = true;
            this.save();
            this.displayWindow();
        }
        return;
    }

    if (!this.promotion) {
        this.startPromotion();
    }

    if (!this.promotion) {
        return;
    }

    this.logCrossOnce("loggedAvailable", cleverapps.EVENTS.CPROMO_AVAILABLE);

    cleverapps.sideBar.resetByClassName(RewardedPromoIcon);

    if (!this.guideShown) {
        this.displayWindow();
        return;
    }

    if (Date.now() - this.lastShown >= RewardedPromoConfig.TRY_WINDOW_TIMEOUT) {
        this.displayTryWindow();
    }
};

RewardedPromo.prototype.displayTryWindow = function () {
    cleverapps.focusManager.display({
        focus: "TryRewardedPromoWindow",
        action: function (f) {
            this.lastShown = Date.now();
            this.save();
            new TryRewardedPromoWindow(this.promotion);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
};

RewardedPromo.prototype.displayWindow = function () {
    cleverapps.focusManager.display({
        focus: "RewardedPromoWindow",
        actions: [
            !this.guideShown && !this.promotion.isEnded() && function (f) {
                this.guideShown = true;
                this.save();
                new RewardedPromoRulesWindow(this.promotion);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this),
            function (f) {
                if (!this.crossId) {
                    f();
                    return;
                }

                const crossId = this.crossId;
                connector.multi.rewardedpromo.loadData(crossId, (error, data) => {
                    if (!error && data && data.projectId && RewardedPromoConfig.PROJECTS[data.projectId]
                        && this.crossId === crossId && this.promotion) {
                        this.promotion.updateData(data);
                        cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
                    }
                    f();
                });
            }.bind(this),
            function (f) {
                this.lastShown = Date.now();
                this.save();

                if (!this.promotion.isEnded()) {
                    this.logCrossOnce("loggedShown", cleverapps.EVENTS.CPROMO_SHOWN);
                }

                const WindowClass = this.promotion.isActive() && this.promotion.isFullyClaimed() ? RewardedPromoCompletedWindow : RewardedPromoWindow;
                new WindowClass(this.promotion);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        ].filter(Boolean)
    });
};

RewardedPromo.prototype.acknowledgeEnd = function () {
    if (this.promotion.isConnected()) {
        this.completedProjects.push(this.promotion.projectId);
    }

    this.lastShown = 0;
    this.endShown = false;
    this.crossId = undefined;
    this.promotion = undefined;
    this.seenCompleted = 0;

    this.loggedAvailable = false;
    this.loggedShown = false;
    this.loggedFirstLaunch = false;
    this.save();
    cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
};

// games without soft currency show their hard currency as gold coins, so the promo windows say "gold" instead of "rubies"
RewardedPromo.WindowTitle = function (windowName) {
    const key = `${windowName}.title`;
    return cleverapps.config.features.includes("soft") ? key : `${key}.gold`;
};

RewardedPromo.getScheduledEvent = function (projectId) {
    const config = RewardedPromoConfig.PROJECTS[projectId];
    return config.feature && cleverapps.eventManager.getFeatureEvent(config.feature);
};

// the window with enough of it left to start a promotion
RewardedPromo.findScheduledEvent = function (projectId) {
    const event = RewardedPromo.getScheduledEvent(projectId);

    return event && event.getTimeLeft() >= RewardedPromoConfig.MIN_REMAINING ? event : undefined;
};

RewardedPromo.prototype.startPromotion = function (projectId) {
    // a target names the games that promote it and the schedule event that opens its window, the first open window
    // in config order wins; the tool may force any target and gets MIN_REMAINING without an event
    const projects = Object.keys(RewardedPromoConfig.PROJECTS)
        .filter((id) => !this.completedProjects.includes(id))
        .filter((id) => !RewardedPromoConfig.PROJECTS[id].sources || RewardedPromoConfig.PROJECTS[id].sources.includes(cleverapps.config.name));

    projectId = projectId || projects.find((id) => RewardedPromo.findScheduledEvent(id));
    if (!projectId) {
        return;
    }

    const event = RewardedPromo.findScheduledEvent(projectId);

    const crossId = RewardedPromotion.PlayerKey(cleverapps.config.name, projectId);
    if (!crossId && !connector.platform.canPassPayload()) {
        // neither a player id nor a payload channel - a random crossId would never reach the target
        console.warn("RewardedPromo.startPromotion: no player id and no payload channel, nothing would ever reach the target");
        return;
    }

    this.lastShown = 0;

    this.crossId = crossId || Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    this.promotion = new RewardedPromotion(this.crossId);
    this.seenCompleted = 0;

    this.loggedAvailable = false;
    this.loggedShown = false;
    this.loggedFirstLaunch = false;

    const data = {
        sourceId: cleverapps.config.name,
        projectId,
        started: Date.now(),
        finish: event ? event.finish.getTime() : Date.now() + RewardedPromoConfig.MIN_REMAINING,
        schedule: event ? RewardedPromoConfig.PROJECTS[projectId].feature : undefined,
        expectedReward: RewardedPromoSource.computeExpectedReward(),
        hostPayerTier: cleverapps.paymentsHistory.classify()
    };
    this.promotion.updateData(data);
    this.save();

    connector.multi.rewardedpromo.updateData(this.crossId, data);
};

cleverapps.InitByFeature["rewarded_promo"] = function () {
    cleverapps.rewardedPromo = new RewardedPromo();

    if (cleverapps.toolModel) {
        ToolModel.AUTONAVIGATE.push({
            windows: ["RewardedPromoWindow"],
            path: ["rewardedPromo"]
        });
    }

    cleverapps.eventBus.on("userChanged", () => {
        cleverapps.rewardedPromo.reset();
    });

    connector.platform.on("changeStatus", () => {
        cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
    });
};

Placements.ENTRIES["chooseRewardedPromo"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,

    filter: function () {
        return cleverapps.rewardedPromo.canDisplay();
    },

    action: function () {
        cleverapps.rewardedPromo.chooseAndDisplay();
    }
};
